import { MapPin } from "lucide-react";
import { SectionHeader } from "./SectionHeader";
import { useI18n } from "@/i18n";
import { confirmedServiceAreas } from "@/config/service-areas";
import { localizePath } from "@/i18n";
import { localizeServiceArea } from "@/i18n/content";

export function ServiceAreas() {
  const { t, locale } = useI18n();

  return (
    <section id="service-areas" className="section-y border-y border-border bg-muted/50">
      <div className="container-page">
        <SectionHeader eyebrow={t.areas.eyebrow} title={t.areas.title} body={t.areas.body} />

        <ul className="mt-10 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
          {confirmedServiceAreas.map((sourceArea) => {
            const area = localizeServiceArea(sourceArea, locale);
            return (
              <li key={area.slug}>
                <a
                  href={localizePath(`/service-areas/${area.slug}`, locale)}
                  className="flex min-w-0 items-center gap-2.5 rounded-lg border border-border bg-card px-4 py-3.5 transition-colors hover:border-accent"
                >
                  <MapPin className="size-4 shrink-0 text-accent" aria-hidden="true" />
                  <span className="truncate text-sm font-medium text-foreground">{area.name}</span>
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
